import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { updateWechatState } from "../../../redux/slice/wechatSlice";
import {
  Form,
  Input,
  Button,
  Toast,
  NoticeBar,
} from 'antd-mobile';
import {
  FrownOutline,
  ScanningOutline
} from 'antd-mobile-icons';
import BottomNavLayout from "../../../components/BottomNavLayout";
import PubHeader from "../../../components/PubHeader";
import api from "../../../api";
import { isWxOrAli } from "../../../utils/env";

const CardBind = () => {
  const wechatState = useSelector((state) => state.wechat)
  const dispatch = useDispatch()

  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [error, setError] = useState('');
  const [cardNo, setCardNo] = useState('');

  // 处理ios异常url
  let url = wechatState.ios ? wechatState.url : window.location.href;

  // 判断当前是微信 or 支付宝
  const aliOrWx = isWxOrAli();

  // 获取全局wx对象
  const wx = window.wx;
  const AlipayJSBridge = window.AlipayJSBridge;

  // 扫码
  // https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#50
  const handleClickScan = () => {
    if (aliOrWx === 'alipay') {
      alipayScanQRCode()
    } else if (aliOrWx === 'wechat') {
      wxScanQRCode()
    }
  }

  const wxScanQRCode = () => {
    wx.scanQRCode({
      needResult: 1,
      scanType: ["qrCode"],
      success: function (res) {
        const sno = res.resultStr;
        form.setFieldValue('cardNo', sno);
      },
      fail: function (res) {
        // alert("error: " + JSON.stringify(res))
      }
    })
  }

  const alipayScanQRCode = () => {
    AlipayJSBridge.call('scan', {
      scanType: ['qrCode'],
      hideAlbum: true,
    }, function (result) {
      if (result.error) {
        return
      }

      const sno = result.qrCode;
      form.setFieldValue('cardNo', sno);
    });
  }

  // 微信初始化配置
  // https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#4
  const wxConfig = (realAuthUrl) => {
    api.wechatJsapiSignature({ url: realAuthUrl }).then((res) => {
      let signature = res.data.data;
      signature.jsApiList = ['scanQRCode', 'chooseWXPay'];
      signature.openTagList = ['wx-open-launch-weapp'];

      wx.config(signature);

      wx.ready(function () {
        // IOS环境特殊处理
        if (wechatState.ios) {
          const newWechatState = {
            url: wechatState.url,
            ios: wechatState.ios,
            loaded: wechatState.loaded,
            iosReady: true
          }
          dispatch(updateWechatState(newWechatState))
        }
      });

      wx.error(function (res) {
        // alert("error : " + JSON.stringify(res))
      });
    });
  }

  const doSetError = (msg) => {
    setError(msg)
    setTimeout(() => {
      setError('')
    }, 2000);
  }

  const validateCardNo = (cardNo) => {
    const cardNoReg = new RegExp('^\\d{10}$')
    const cardNoValid = cardNoReg.test('' + cardNo)
    if (!cardNoValid) {
      doSetError('请输入10位数字卡号')
    }
    return cardNoValid
  }

  const onSubmit = async () => {
    const values = form.getFieldsValue()
    const { cardNo } = values

    if (!validateCardNo(cardNo)) {
      return
    }

    const resp = await api.userCardBind({ cardNo })
    if (resp.data?.code === 0) {
      Toast.show({ content: resp.data.message })

      setTimeout(() => {
        navigate('/card/list')
      }, 600);
    } else {
      doSetError('绑定失败，请稍后再试')
    }
  }

  useEffect(() => {
    if (aliOrWx === 'wechat') {
      // 非ios平台每次都需要config
      if (!wechatState.ios) {
        wxConfig(url)
      } else if (wechatState.iosReady) {

      } else {
        wxConfig(url)
      }
    }
  }, [])

  return (
    <BottomNavLayout>
      <PubHeader title="绑定IC卡" />

      <div>
        <div className="error-wrapper">
          {error ?
            <NoticeBar
              icon={<FrownOutline />}
              content={error}
              color='error'
            /> : undefined
          }
        </div>

        <Form
          form={form}
          layout='horizontal'
          footer={
            <Button block color='success' size='large' onClick={onSubmit}>
              绑 定
            </Button>
          }
        >
          <Form.Item
            name='cardNo'
            label='卡号'
            // initialValue={cardNo}
            extra={<div style={{ margin: '0 12px 0 0' }} ><ScanningOutline onClick={() => handleClickScan()} /></div>}
            rules={[
              { required: true, message: '卡号不能为空' }
            ]}
          >
            <Input
              placeholder='请输入IC卡号'
              autoFocus={true}
              type='number'
              clearable={true}
              defaultValue={cardNo}
              value={cardNo}
            />
          </Form.Item>

          <Form.Item
            name='remark'
            label='备注'
            rules={[
              { required: true, message: '请输入备注' }
            ]}
          >
            <Input
              placeholder='请输入备注'
              type='text'
              clearable={true}
            />
          </Form.Item>
        </Form>
      </div>
    </BottomNavLayout>
  )
}

export default CardBind